import React from 'react';
 
import logo from './logo192.png';
import './App.css';
import {
  BrowserRouter as Router,
  Link,
  Switch,
  Route
} from 'react-router-dom';
import RootComponent from './rootcomponent';
import HomeComponent from './homecomponent';
 
function App() {
   return (
     <div className="App">
     
       <Router>
             <Switch>
                <Route path="/list">
                   <div>item list</div>
               </Route>
                <Route path="/add">
                <div>item form</div>
                </Route>
                <Route path="/:id" >
                <RootComponent/> 
                </Route>
                <Route path="/" >
                <HomeComponent/> 
                </Route>
             </Switch>
          
       </Router>
     </div>
   );
 }

export default App;
